module.exports = window.ReactIs;